/**
 * Mega Menu — desktop only (≥992px)
 *
 * Behaviour:
 *  - Reads all [data-mega-menu] slugs from the rendered panels.
 *  - For each #menu-primary-menu > li, checks if it has that slug as a CSS
 *    class. Fallback: derives a slug from the link href (last URL segment,
 *    prefixed with "menu-") so editors don't need to add a CSS class manually.
 *  - Hover-to-open with an 80-100ms bridge timeout so moving the cursor
 *    diagonally from the nav link into the panel doesn't close it.
 *  - Uses jQuery fadeIn(150) / fadeOut(100) to show/hide panels.
 *  - Adds .mega-menu-active to #mainMenu while a panel is open so CSS can
 *    dim non-active primary items.
 *  - Hides the WP sub-menu of a mega-menu item so both don't show at once.
 *  - Hover-image: the original <img> inside ul.menu <a> tags is hidden on
 *    desktop (CSS). On hover, JS reads the src and injects it into
 *    .hoverImageSlot (right column) so it displays at full size.
 *  - Closes on Escape key and when #menuTrigger is clicked (overlay closing).
 *  - On tablet/mobile (<992px) this script does nothing; the normal WP
 *    overlay menu works exactly as before.
 *  - Conservatory / Living Space toggle buttons are wired up here.
 */

(function ($) {

    'use strict';

    var DESKTOP_BP = 992; // px — must match the SCSS breakpoint

    function isMobile() {
        return $(window).width() < DESKTOP_BP;
    }

    /* ── Build the slug list from rendered panels ── */
    var megaMenuArr = [];
    $('.mega-menu[data-mega-menu]').each(function () {
        var slug = $(this).data('mega-menu');
        if (slug) megaMenuArr.push(slug);
    });

    /**
     * Given a primary-menu <li>, return the matching mega-menu slug or null.
     * 1. Check if the <li> has the slug as a CSS class.
     * 2. Fallback: derive slug from the href of the <a> (last URL segment,
     *    prefixed with "menu-").
     */
    function getMegaMenuSlug($li) {
        var i, slug;

        // 1. Class match
        for (i = 0; i < megaMenuArr.length; i++) {
            if ($li.hasClass(megaMenuArr[i])) return megaMenuArr[i];
        }

        // 2. href-derived fallback
        var href = ($li.find('> a').attr('href') || '').replace(/\/$/, '');
        var segment = href.split('/').pop();
        slug = 'menu-' + segment;
        for (i = 0; i < megaMenuArr.length; i++) {
            if (megaMenuArr[i] === slug) return slug;
        }

        return null;
    }

    /* ── Hover-image slot helpers ── */

    var $hoverSlot    = $('.hoverImageSlot');
    var $hoverSlotImg = $hoverSlot.find('img');

    function showHoverImage(src, alt) {
        if (!src) {
            hideHoverImage();
            return;
        }
        $hoverSlotImg.attr({ src: src, alt: alt || '' });
        $hoverSlot.addClass('is-active');
    }

    function hideHoverImage() {
        $hoverSlot.removeClass('is-active');
    }

    /* ── Mega-menu helpers ── */

    function closeAll() {
        $('.mega-menu').stop(true, true).fadeOut(100);
        $('#mainMenu').removeClass('mega-menu-active');
        $('#menu-primary-menu > li.mega-menu-open').removeClass('mega-menu-open');
        hideHoverImage();
    }

    function openMegaMenu(slug, $li) {
        // Hide all other panels immediately, then fade in the target
        $('.mega-menu').not('[data-mega-menu="' + slug + '"]').stop(true, true).hide();
        $('[data-mega-menu="' + slug + '"]').stop(true, true).fadeIn(150);

        // Suppress the WP sub-menu for this item
        $li.find('> .sub-menu').hide();

        // State classes
        $('#mainMenu').addClass('mega-menu-active');
        $('#menu-primary-menu > li.mega-menu-open').removeClass('mega-menu-open');
        $li.addClass('mega-menu-open');

        // Hide hover image (mega menu takes over the slot)
        hideHoverImage();
    }

    /* ── Initialise on DOM ready ── */

    $(document).ready(function () {

        /* Mark primary-menu items that have a matching mega menu */
        $('#menu-primary-menu > li').each(function () {
            var slug = getMegaMenuSlug($(this));
            if (slug) {
                $(this).addClass('has-mega-menu');
                $(this).find('> a').addClass('has-mega-menu-arrow');
            }
        });

        /* ── Desktop hover logic ── */

        var hideTimeout;

        $('#menu-primary-menu > li').hover(
            /* mouseenter */
            function () {
                if (isMobile()) return;
                clearTimeout(hideTimeout);

                var $li  = $(this);
                var slug = getMegaMenuSlug($li);

                if (slug) {
                    openMegaMenu(slug, $li);
                } else {
                    // Non-mega item: close any open mega panel, show hover image
                    $('.mega-menu').stop(true, true).fadeOut(100);
                    $('#mainMenu').removeClass('mega-menu-active');
                    $('#menu-primary-menu > li.mega-menu-open').removeClass('mega-menu-open');

                    // Show this item's hover image in the right slot
                    var $img = $li.find('> a > img');
                    if ($img.length) {
                        showHoverImage($img.attr('src'), $img.attr('alt'));
                    } else {
                        hideHoverImage();
                    }
                }
            },
            /* mouseleave */
            function () {
                if (isMobile()) return;
                var slug = getMegaMenuSlug($(this));
                if (slug) {
                    hideTimeout = setTimeout(function () {
                        if (!$('.mega-menu:hover').length) {
                            closeAll();
                        }
                    }, 80);
                } else {
                    hideTimeout = setTimeout(function () {
                        if (!$('.mega-menu:hover').length) {
                            hideHoverImage();
                        }
                    }, 80);
                }
            }
        );

        /* Keep panel open while mouse is inside it */
        $(document).on('mouseenter', '.mega-menu', function () {
            if (isMobile()) return;
            clearTimeout(hideTimeout);
            $(this).stop(true, true).show();
        }).on('mouseleave', '.mega-menu', function () {
            if (isMobile()) return;
            hideTimeout = setTimeout(function () {
                if (!$('.mega-menu:hover').length) {
                    closeAll();
                }
            }, 80);
        });

        /* ── Escape key closes ── */
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAll();
            }
        });

        /* ── Close mega menu when the WP overlay menu opens/closes ── */
        $('#menuTrigger').on('click', function () {
            closeAll();
        });

        /* ── On window resize: close if we drop below desktop BP ── */
        $(window).on('resize', function () {
            if (isMobile()) {
                closeAll();
            }
        });

        /* ── Conservatory / Living Space toggle buttons ── */
        $(document).on('click', '.show-conservatory-links', function () {
            var $btn      = $(this);
            var target    = $btn.data('target');
            var $target   = $('#' + target);
            var labelShow = $btn.data('label-show') || 'Show';
            var labelHide = $btn.data('label-hide') || 'Hide';

            if (!$target.length) return;

            if ($target.hasClass('hidden')) {
                $target.removeClass('hidden');
                $btn.text(labelHide);
            } else {
                $target.addClass('hidden');
                $btn.text(labelShow);
            }
        });

    });

})(jQuery);
